<template>
    <div id="datatable-notifications-backoffice">
        <v-data-table
            :headers="headers"
            :items="listNotifications"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50],
            }"
            dense
        >
            <template v-slot:[`item.image`]="{ item }">
                <div v-show="item.image">
                    <img
                        :src="item.image"
                        :alt="item.title"
                        style="width: 40px"
                    />
                </div>
            </template>
            <template v-slot:[`item.bodyText`]="{ item }">
                <div
                    v-if="item.bodyText && item.bodyText.length <= 150"
                    v-html="$helpers.getSafeMarkdown(item.bodyText)"
                />
                <div
                    v-else
                    v-html="
                        $helpers.getSafeMarkdown(
                            item.bodyText
                                ? item.bodyText.slice(0, 150) + '...'
                                : ''
                        )
                    "
                />
            </template>
            <template v-slot:[`item.title`]="{ item }">
                <div v-html="$helpers.getSafeMarkdown(item.title)"></div>
            </template>
            <template v-slot:[`item.updateDatetime`]="{ item }">
                <span>{{ item.updateDatetime | formatDateTimezone }}</span>
            </template>
            <template v-slot:[`item.inicialDatetime`]="{ item }">
                <span>{{ item.inicialDatetime | formatDateTimezone }}</span>
            </template>
            <template v-slot:[`item.expiresDatetime`]="{ item }">
                <span>{{ item.expiresDatetime | formatDateTimezone }}</span>
            </template>
            <template v-slot:[`item.languageCodes`]="{ item }">
                <v-chip
                    v-for="(l, index) in item.languageCodes"
                    :key="index"
                    pill
                    class="language-code"
                >
                    {{ l }}
                </v-chip>
            </template>
            <template v-slot:[`item.isNotificationValid`]="{ item }">
                <v-chip
                    :color="getColor(item.notificationStatusId)"
                    pill
                    dark
                    class="status-column"
                >
                    {{ item.notificationStatus }}
                </v-chip>
            </template>
            <template v-slot:[`item.config`]="props">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            style="cursor: pointer"
                            class="circle"
                            @click="onConfigClicked(props.item, 'preview')"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/eye.svg"
                                :alt="$t('backoffice.actions.view')"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </span>
                    </template>
                    <span>{{ $t("backoffice.actions.view") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            style="cursor: pointer"
                            class="circle"
                            @click="onConfigClicked(props.item, 'edit')"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/edit_pencil.svg"
                                alt="editar"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </span>
                    </template>
                    <span>{{ $t("backoffice.actions.edit") }}</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listNotifications: Array | Object,
        searchCount: Number,
        totalItems: Number | String,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t("backoffice.notifications.image"),
                    align: "start",
                    value: "image",
                    width: "5%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.notifications.title1"),
                    align: "start",
                    value: "title",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.notifications.text"),
                    align: "start",
                    value: "bodyText",
                    width: "23%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.general.modified-date"),
                    align: "start",
                    value: "updateDatetime",
                    width: "13%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("backoffice.general.start-date"),
                    align: "start",
                    value: "inicialDatetime",
                    width: "10%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("backoffice.general.expiration-date"),
                    align: "start",
                    value: "expiresDatetime",
                    width: "13%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("language"),
                    align: "start",
                    value: "languageCodes",
                    width: "5%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.notifications.expiration"),
                    align: "center",
                    value: "isNotificationValid",
                    width: "9%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: "",
                    value: "config",
                    sortable: false,
                    align: "end",
                    width: "15%",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
    },
    methods: {
        getColor(status) {
            if (status == 1) return "gray";
            else if (status == 2) return "green";
            else return "orange";
        },
        onConfigClicked(item, type) {
            this.$router.push({
                name: "backoffice-edit-notifications",
                params: { type: type, notification_id: item.notificationId },
            });
        },
    },
};
</script>
<style>
.language-code.v-chip.v-size--default {
    height: 15px !important;
    padding: 7px !important;
}
</style>
<style lang="scss">
@import "@sass/_variables.scss";
#datatable-notifications-backoffice {
    tr {
        height: 42px;
    }
    .language-code {
        text-align: center;
        margin: 2px;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 8px;
        }
        .v-size--default {
            height: 10px !important;
        }
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 5px;
        margin-top: 5px;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        @media (max-width: 599px) {
            display: block !important;
        }
        .service {
            @media (max-width: 599px) {
                float: left;
            }
        }
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 10px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }
    .star {
        color: #ffc117 !important;
    }

    .bold-style {
        font-weight: bold;
    }

    .v-data-footer {
        margin-right: 40px !important;
    }

    .btn-show-hours {
        width: 14rem;
        text-transform: initial;
        color: white;
        background-color: var(--v-primary-base);
    }
}
#public-btn {
    width: 14rem;
    text-transform: initial;
    color: white;
    background-color: var(--v-primary-base) !important;
}

.v-menu__content[role="menu"] {
    .v-small-dialog__content {
        padding: 0 !important;
    }
}

.theme--light.v-small-dialog__actions,
.theme--light.v-small-dialog__menu-content {
    left: 1110px !important;
}

@media (max-width: 1025px) {
    .theme--light.v-small-dialog__actions,
    .theme--light.v-small-dialog__menu-content {
        left: 780px !important;
    }
}

@media (min-width: 1450px) and (max-width: 1439px) {
    .theme--light.v-small-dialog__actions,
    .theme--light.v-small-dialog__menu-content {
        left: 1360px !important;
    }
}

@media (min-width: 2559px) {
    .theme--light.v-small-dialog__actions,
    .theme--light.v-small-dialog__menu-content {
        left: 1704px !important;
    }
}
</style>
